import React from 'react'
import SharedToolPage from '../components/Layout/SharedToolPage'
import AdminFilesView from './admin/tools/AdminFilesView'

export default function Files({ embedded = false }) {
  return (
    <SharedToolPage embedded={embedded}>
      <AdminFilesView />
    </SharedToolPage>
  )
}
